import React from "react";
import { graphql } from "gatsby";
import { Box, useTheme } from "@material-ui/core";
import deepEqual from "react-fast-compare";

function Spacer({ heightXs, heightSm, heightMd, heightLg, heightXl }) {
  const theme = useTheme();
  return (
    <Box
      key={[heightXs, heightSm, heightMd, heightLg, heightXl].join("-")} // Improve hot refresh when editing in the CMS
      width="100%"
      minHeight={{
        xs: typeof heightXs === "number" ? theme.spacing(heightXs) : undefined,
        sm: typeof heightSm === "number" ? theme.spacing(heightSm) : undefined,
        md: typeof heightMd === "number" ? theme.spacing(heightMd) : undefined,
        lg: typeof heightLg === "number" ? theme.spacing(heightLg) : undefined,
        xl: typeof heightXl === "number" ? theme.spacing(heightXl) : undefined
      }}
    />
  );
}

export default React.memo(Spacer, deepEqual);

export const SpacerFragment = graphql`
  fragment SpacerFragment on DatoCmsCModuleSpacer {
    heightXs
    heightSm
    heightMd
    heightLg
    heightXl
    container
    containerDisableGutters
    containerBackgroundColor
    visibilitySettings {
      ...ContentModuleVisibilitySettingFragment
    }
    model {
      apiKey
    }
  }
`;
